import { StorageStrategy } from 'Faster/storage/StorageStrategy';

class StorageEngine {
  private storages: StorageStrategy[];
  private storedKeys: string[] = [];

  public constructor(storages: StorageStrategy[]) {
    this.storages = storages;
  }

  public store(key: string, data: string): void {
    this.storeInAllStorages(key, data);
    this.setKeyInUse(key);
  }

  public retrieve(key: string, validator: (data: string) => boolean = (): boolean => true): string | undefined {
    const data = this.searchInAllStorages(key, validator);
    if (data != null) {
      this.storeInAllStorages(key, data);
      this.setKeyInUse(key);
    }

    return data;
  }

  private searchInAllStorages(key: string, validator: (data: string) => boolean): string | undefined {
    const availableStorage = this.storages.find((storage): boolean => {
      try {
        const storageData = storage.retrieve(key);
        if (storageData == null) {
          return false;
        }
        const isDataValid = validator(storageData);
        if (!isDataValid) {
          storage.remove(key);
          return false;
        }

        return true;
      } catch (e) {
        return false;
      }
    });

    if (availableStorage == undefined) {
      return null;
    }
    return availableStorage.retrieve(key);
  }

  private storeInAllStorages(key: string, data: string) {
    this.storages.forEach((storage) => {
      try {
        return storage.store(key, data);
        // eslint-disable-next-line no-empty
      } catch (e) {}
    });
  }

  private setKeyInUse(key: string): void {
    if (this.storedKeys.indexOf(key) === -1) {
      this.storedKeys.push(key);
    }
  }

  public startUpdateInterval(interval: number): void {
    setInterval((): void => {
      this.storedKeys.forEach((key: string): void => {
        const data = this.retrieve(key);
        if (data) {
          this.store(key, data);
        }
      });
    }, interval);
  }
}

export default StorageEngine;
